import React from 'react';
import {
    Button,
    Caption,
    Flex,
    Label,
    pxArrayToRem,
    pxToRem,
    useStyles,
} from '@archipro-design/aria';
import * as S from './ProductTaggingModal.style';
import { CloseLine } from '@archipro-design/icons';

interface ProductTaggingModalProps {
    title?: string;
    message: JSX.Element | string;
    onConfirm?: (e: React.SyntheticEvent<HTMLElement>) => void;
    disableFooterButton?: boolean;
    onCancel?: () => void;
    children?: React.ReactNode;
    hideFooter?: boolean;
}

const ProductTaggingModal = ({
    title = 'Awaiting confirmation',
    message,
    onConfirm,
    disableFooterButton = false,
    onCancel,
    children,
    hideFooter = false,
}: ProductTaggingModalProps) => {
    const { css } = useStyles();

    return (
        <div className={css(S.ProductTaggingModal)}>
            <Flex className={css(S.ModalHeader)}>
                <Label variant="01" className={css(S.Title)}>
                    {title}
                </Label>
                <Button
                    onClick={onCancel}
                    icon={<CloseLine />}
                    color={'dark'}
                    size={32}
                    transparent={true}
                    variables={{
                        iconPadding: 0,
                        buttonPadding: pxArrayToRem([0, 15]),
                    }}
                />
            </Flex>
            <div className={css(S.ModalBody)}>
                <Caption variant="01" className={css(S.Message)}>
                    {message}
                </Caption>
                {children}
            </div>
            {!hideFooter && (
                <div className={css(S.ModalFooter)}>
                    <Button
                        color={'grey'}
                        type={'submit'}
                        size={20}
                        variables={{
                            buttonMinWidth: '100%',
                            buttonPadding: pxToRem(12),
                        }}
                        onClick={onConfirm}
                        disabled={disableFooterButton}
                    >
                        Remove Tag
                    </Button>
                </div>
            )}
        </div>
    );
};

export default ProductTaggingModal;
